<template>
	<div>
		<aboutCenNav ref="aboutCenNav" :list="navList" @goScroll="goScroll" v-show="cenNavHidden"></aboutCenNav>
		<div class="aboutBoxOne" v-if="zzjgImg">
			<div>
				<indexTitle ref="zzjg" :title="$t('i18n_10')" :more="false" mabot="18px"></indexTitle>
				<abInZzjg :zzjgImg="zzjgImg"></abInZzjg>
			</div>
		</div>
		<div class="aboutBoxTwo">
			<indexTitle ref="yjzy" :title="$t('i18n_11')" :more="false" mabot="96px"></indexTitle>
			<div style="margin-bottom: 60px;">
				<abInyjzy :yjzy="yjzyOne" v-if="yjzyOne"></abInyjzy>
				<abInyjzy :yjzy="yjzyTwo" v-if="yjzyTwo"></abInyjzy>
				<abInyjzy :yjzy="yjzyThree" v-if="yjzyThree"></abInyjzy>
			</div>
			<indexTitle ref="gphq" :title="$t('i18n_12')" :more="false" mabot="35px"></indexTitle>
			<div class="gphqBox">
				<div>{{$t('i18n_13')}}：</div>
				<div @click="goTz">{{investDetail.stock_market?investDetail.stock_market.text:''}}</div>
			</div>
			<indexTitle ref="tzzlx" :title="$t('i18n_14')" :more="false" mabot="37px"></indexTitle>
			<div class="tzzlxBox">
				<div class="tzzlxBoxFor" v-for="(item,index) in investDetail.contact" :key="index">
					<div class="tzzlxBoxForImg">
						<img :src="item.cover" />
					</div>
					<div class="tzzlxBoxForName">
						{{item.title}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import aboutCenNav from "./aboutCenNav"
	import abInZzjg from "./abInZzjg"
	import abInyjzy from "./abInyjzy"
	import indexTitle from "./indexTitle"
	import {
		get_investor
	} from "@/api/about.js"
	export default {
		components: {
			aboutCenNav,
			indexTitle,
			abInZzjg,
			abInyjzy
		},
		data() {
			return {
				navList: [
					// {
					// 	name: this.$t('i18n_15'),
					// 	value: 'zzjg',
					// },
					{
						name: this.$t('i18n_16'),
						value: 'yjzy',
					},
					{
						name: this.$t('i18n_17'),
						value: 'gphq',
					},
					{
						name: this.$t('i18n_18'),
						value: 'tzzlx',
					},
				],
				navHidden: false,
				scrollTop: 0,
				scrollTopNav: 0,
				cenNavHidden: true,
				navTop: [],
				querValue: '',
				zzjgImg: require('@/assets/about/tzzgx/tzzgx.png'),
				tzzlxList: [{
						img: require('@/assets/about/tzzgx/dh.png'),
						name: '+86-21-54303731'
					},
					{
						img: require('@/assets/about/tzzgx/dy.png'),
						name: '+86-21-67681020'
					},
					{
						img: require('@/assets/about/tzzgx/yj.png'),
						name: 'ir@aohua.com'
					},

				],
				yjzy: [],
				investDetail: {},
				yjzyOne: '',
				yjzyTwo: '',
				yjzyThree: '',
			}
		},
		watch: {
			scrollTop() {
				if (this.scrollTop < this.scrollTopNav) {
					this.cenNavHidden = true;
				}
				this.navList.map((v, a) => {
					if (this.scrollTop == 0) {
						this.$refs.aboutCenNav.current = 0;
						return;
					}
					if (a + 1 == this.navList.length) {
						if ((this.scrollTop + 70) > this.navTop[a]) {
							this.$refs.aboutCenNav.current = a;
						}
					} else {
						if ((this.scrollTop + 70) > this.navTop[a] && (this.scrollTop + 70) < this.navTop[a + 1]) {
							this.$refs.aboutCenNav.current = a;
						}
					}
				})
			},
			querValue() {
				let t = this;
				t.setTop();
			}
		},

		mounted() {
			let t = this;
			let offsetTop = this.$refs.aboutCenNav.$el.offsetTop;
			this.scrollTopNav = offsetTop;
			window.addEventListener('scroll', this.handleScroll);
			this.querValue = this.$route.query.value;

			this.getInvestList();
			console.log(this.querValue, "嗷嗷")
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			setTop() {
				this.navList.map((v, a) => {
					if (this.querValue == v.value) {
						this.$refs.aboutCenNav.current = a;
						this.goScroll(this.querValue)
					}

				})
			},
			getTop() {
				let top = [];
				this.navList.map((v, a) => {
					if (v.value == 'qb') {
						top.push('')
					} else {
						top.push(this.$refs[v.value].$el.offsetTop)
						console.log(top)
					}
				})
				this.$nextTick(function() {
					this.navTop = top;
				})
				console.log(this.navTop)
			},
			goScroll(e) {
				let offsetTop = this.$refs[e].$el.offsetTop - 70;
				this.$emit('goScroll', offsetTop)
			},
			handleScroll(e) {
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				this.scrollTop = element.scrollTop;
			},
			goTz() {
				window.open(this.investDetail.stock_market.url, '_blank')
			},
			getInvestList() {
				let t = this;
				let data = {}
				get_investor(data).then(res => {
					console.log(res, "获取成功了啊啊")
					let info = res.data.info;
					this.zzjgImg = info.structure;
					this.investDetail = info;
					this.yjzyOne = {
						head: info.performance_summary.header1,
						data: info.performance_summary.tableData1,
					}
					this.yjzyTwo = {
						head: info.performance_summary.header2,
						data: info.performance_summary.tableData2,
						dw: this.$t('i18n_19')
					}
					this.yjzyThree = {
						head: info.performance_summary.header3,
						data: info.performance_summary.tableData3,
					}
					this.$nextTick(function() {
						t.scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
						t.getTop();
					})
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.gphqBox {
		display: flex;
		margin-bottom: 156px;

		>div {
			// font-size: 26px;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
		}

		>div:nth-of-type(1) {
			color: #000000;
		}

		>div:nth-of-type(2) {
			color: #777777;
			cursor: pointer;
		}
	}

	.tzzlxBox {
		padding-bottom: 200px;

		.tzzlxBoxFor {
			display: flex;
			align-items: center;
			margin-bottom: 21px;

			.tzzlxBoxForImg {
				margin-right: 18px;

				img {
					width: 35px;
					height: 35px;
				}
			}

			.tzzlxBoxForName {
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #777777;
			}
		}
	}

	.aboutBoxOne {
		width: 100%;
		background-color: #ECECEC;

		>div {
			width: 1200px;
			margin: 0px auto;
			padding-top: 130px;
			padding-bottom: 86px;
		}
	}

	.aboutBoxTwo {
		width: 1200px;
		margin: 0px auto;
		padding-top: 106px;
	}

	@media screen and (max-width:1200px) {
		.aboutBoxOne {
			>div {
				width: 100% !important;
				padding-top: 30px !important;
				padding-bottom: 30px !important;
			}
		}

		.aboutBoxTwo {
			width: 100% !important;
			padding-top: 30px !important;
		}

		.gphqBox {
			margin-bottom: 30px !important;
			padding: 0 30px;
			>div {
				// font-size: 26px;
				font-size: 14px !important;
			}
		}
		.tzzlxBox {
			padding:0 30px 30px !important;
			.tzzlxBoxFor {
		
				.tzzlxBoxForImg {
					img {
						width: 20px !important;
						height: 20px !important;
					}
				}
		
				.tzzlxBoxForName {
					font-size: 14px  !important;
				}
			}
		}
	}
</style>